import type { FormEventHandler } from "react";
import useTranslator from "../../hooks/useTranslator";
import PasswordInput from "./PasswordInput";
import type { AuthScreen } from "../../pages/auth/authFlow";
import styles from "../../pages/onboarding/BasicInfoModal.module.css";

interface PasswordFormProps {
  title: string;
  subtitle: string;
  isTwo: boolean;
  isProvidePassword?: boolean;
  passwordValue: string;
  onChangePassword: (event: React.ChangeEvent<HTMLInputElement>) => void;
  repeatPasswordValue: string;
  submitHandler: FormEventHandler<HTMLFormElement>;
  disabled: boolean;
  setCurrentScreen: (screen: AuthScreen) => void;
  sendOtpFun: () => void;
  inputError: string;
  setInputError: (error: string) => void;
}

const PasswordForm = ({
  title,
  subtitle,
  isTwo,
  isProvidePassword = true,
  passwordValue,
  onChangePassword,
  repeatPasswordValue,
  submitHandler,
  disabled,
  setCurrentScreen,
  sendOtpFun,
  inputError,
  setInputError,
}: PasswordFormProps) => {
  const { _t } = useTranslator();
  return (
    <form onSubmit={submitHandler} className="formInformation passwordFormInfo">
      <button
        type="button"
        onClick={() => setCurrentScreen("email")}
        className={styles.backButton}
      >
        <span aria-hidden="true">&#8249;</span>
        {_t("back")}
      </button>
      <h2>{title}</h2>
      <p>{subtitle}</p>
      <PasswordInput
        name="password"
        onChange={onChangePassword}
        value={passwordValue}
        inputError={inputError}
        setInputError={setInputError}
        isShowChecks={isTwo}
      />
      {isProvidePassword && (
        <a
          onClick={() => setCurrentScreen("forgotPassword")}
          className="forgotPassword"
        >
          {_t("forgotPassword")}
        </a>
      )}
      {isTwo && (
        <PasswordInput
          name="confirmPassword"
          value={repeatPasswordValue}
          label={_t("repeatPassword")}
          onChange={onChangePassword}
          inputError={inputError}
          setInputError={setInputError}
        />
      )}
      {inputError && <p className="error-message">{inputError}</p>}
      <button
        disabled={disabled}
        type="submit"
        className="btnNext basicInfoButton greenHover"
      >
        {_t("submit")}
      </button>
      {isProvidePassword && (
        <p className="continueWithOtp">
          {_t("continueWithOtp")}
          <a
            onClick={() => {
              sendOtpFun();
              setCurrentScreen("verifyOtp");
            }}
            className="forgotPassword"
          >
            {_t("clickHere")}
          </a>
        </p>
      )}
    </form>
  );
};

export default PasswordForm;
